// extracted by mini-css-extract-plugin
export default {"section":"forecast_section__EhdpD","article":"forecast_article__-8VP7","content":"forecast_content__UGWNq","imgbox":"forecast_imgbox__IfqqZ","imgbox1":"forecast_imgbox1__KUme2"};